<template>
  <div class="flex h-screen w-full overflow-hidden bg-canvas">
    <Transition name="fade" mode="out-in">
      <slot />
    </Transition>
  </div>
</template>
